<template>
  <div class="id-container">
    <div v-if="step === 1"
         class="read-preview">
      <readCard @get-user-data="getUserData"></readCard>
    </div>
    <recruit v-if="step === 2" :user-data="userData" :studentType="extraParams.studentType" :id="studentId" :showTestResult="false"></recruit>
  </div>
</template>

<script>
import readCard from './readCard.vue'
import recruit from './recruit.vue'
export default {
  components: {
    recruit,
    readCard
  },
  props: {
    visible: Boolean,
    extraParams: Object
  },
  data () {
    return {
      loading: true,
      studentId: '',
      readText: '读卡中，请放身份证',
      step: 1,
      reader: {
        fetching: false
      },
      userData: {}
    }
  },
  methods: {
    getUserData (userData) {
      this.userData = userData
      this.step = 2
    }
  },
  watch: {
    'visible': {
      handler (val) {
        if (val) {
          this.step = 1
          this.studentId = this.$attrs['extra-id'][0]
          if (this.studentId) {
            this.step = 2
          }
        } else {
          this.step = 0
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.id-container {
  width: 1000px;

  .blue-title {
    font-size: 13px;
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;

    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
}

.read-preview {
  width: 100%;
  height: 530px;
  background: #0E5AA7;
  padding: 50px 10px 20px;
}
</style>
